/**
 * stripHTMLFromString
 * @param originalString  remove html from this string
 * @returns
 */
export const stripHTMLFromString = (originalString: string) => {
  if (originalString && typeof originalString === 'string') {
    return originalString.replace(/&amp;/, '&').replace(/(<([^>]+)>)/gi, '');
  } else {
    return originalString;
  }
};

/**
 * Replace non alpha with hypen
 * @param value {string}
 * @returns {string}
 */
export const removeNonAlpaChars = (value: string) => {
  return value ? value.replace(/[^a-zA-Z0-9-]/gim, '-').toLowerCase() : value;
};

/**
 * Capitalises labels
 * @param value {string}
 * @returns {string}
 */
export const capitalise = (value: string) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};

/**
 * Convert string to hash
 * @param string string
 * @returns
 */
export const stringToHash = (string: string) => {
  let hash = 0;
  if (string.length === 0) return hash;
  for (const char of string) {
    hash ^= char.charCodeAt(0); // Bitwise XOR operation
  }
  return hash;
};

export const formatDrupalUri = (uri: string) => {
  return uri.substring(uri.indexOf(':') + 1, uri.length);
};
